import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { UIRouterModule } from '@uirouter/angular';
import { CookieService } from 'ngx-cookie-service';

import { RequestPasswordResetComponent } from './components/request-password-reset/request-password-reset.component';
import { ResetPasswordConfirmComponent } from './components/reset-password-confirm/reset-password-confirm.component';
import { ComponentsModule } from '../components/components.module';
import { SharedModule } from '../shared/shared.module';
import { RegistrationComponent } from './components/registration/registration.component';
import { routes } from './auth.routes';
import { UnsubscribeComponent } from './components/unsubscribe/unsubscribe.component';
import { LoginComponent } from './components/login/login.component';
import { AuthFormComponent } from './components/auth-form/auth-form.component';
import { CreateAccountComponent } from './components/create-account/create-account.component';
import { ConfirmEmailComponent } from './components/confirm-email/confirm-email.component';
import { AuthCommonComponent } from './components/auth-common/auth-common.component';
import { NotificationAlertComponent } from '../components/notification-alert/notification-alert.component';
import { SignOutButtonDirective } from './directives/sign-out-button.directive';
import { ActionLinkDirective } from '../accessibility/directives/action-link/action-link.directive';

@NgModule({
  declarations: [
    RequestPasswordResetComponent,
    ResetPasswordConfirmComponent,
    RegistrationComponent,
    UnsubscribeComponent,
    LoginComponent,
    AuthFormComponent,
    CreateAccountComponent,
    ConfirmEmailComponent,
    AuthCommonComponent,
    SignOutButtonDirective,
  ],
  imports: [
    ActionLinkDirective,
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    UIRouterModule.forChild(routes),
    ComponentsModule,
    SharedModule,
    NotificationAlertComponent,
  ],
  exports: [SignOutButtonDirective, LoginComponent],
  providers: [CookieService],
})
export class AuthModule {}
